import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { report_bill_lang } from "../../language/report_bill";
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-print-report-bill-cancel',
  templateUrl: './print-report-bill-cancel.component.html',
  styleUrls: ['./print-report-bill-cancel.component.scss']
})
export class PrintReportBillCancelComponent implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  total_price = 0;
  total_price_value = '';
  print_datetime = '';
  report = '';
  day: any;
  month: any;
  year: any;
  reports: any;
  isLoading = true;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  base64_img_muni = null;
  img_src = null;
  muni_thname = null;
  muni_amphurth = null;
  muni_tambonth = null;
  muni_thprovince = null;
  muni_postcode = null;
  muni_contact_phone = null;
  date_filter = null;
  municipality = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private sanitizer: DomSanitizer) {
    this.language = report_bill_lang[this.lang];
  }

  ngOnInit() {

    const get_Storage_invoice_multi = sessionStorage.getItem('municipality')
    this.municipality = JSON.parse(get_Storage_invoice_multi)
    this.base64_img_muni = `data:image/png;base64,${JSON.parse(get_Storage_invoice_multi).icon_img}`
    this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
    const thname_muni = JSON.parse(get_Storage_invoice_multi).th_name;
    this.muni_thname = this.sanitizer.bypassSecurityTrustHtml(thname_muni);
    const thamphurth_muni = JSON.parse(get_Storage_invoice_multi).th_amphur;
    this.muni_amphurth = this.sanitizer.bypassSecurityTrustHtml(thamphurth_muni);
    const tambonth_muni = JSON.parse(get_Storage_invoice_multi).th_tambon;
    this.muni_tambonth = this.sanitizer.bypassSecurityTrustHtml(tambonth_muni);
    const provinceth_muni = JSON.parse(get_Storage_invoice_multi).th_province;
    this.muni_thprovince = this.sanitizer.bypassSecurityTrustHtml(provinceth_muni);
    const postcode_muni = JSON.parse(get_Storage_invoice_multi).postcode;
    this.muni_postcode = this.sanitizer.bypassSecurityTrustHtml(postcode_muni);
    const phone_muni = JSON.parse(get_Storage_invoice_multi).contact_phone;
    this.muni_contact_phone = this.sanitizer.bypassSecurityTrustHtml(phone_muni);

    this.route.queryParams.subscribe(params => {
      this.date_filter = null

      //debugger
      if (params['report'] == '1') {
        var x = moment.unix(params['datetime']).locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('DD MMMM ') + xy.toString();
        this.report = '1';
      }
      else if (params['report'] == '2') {
        var dateString = params['month'] + '-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('MMMM ') + xy.toString();
        console.log(this.print_datetime);
        this.report = '6';
      }
      else if (params['report'] == '3') {
        var dateString = '01-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = xy.toString();
        console.log(this.print_datetime);
        this.report = '7';
      }

    });

    this.refresh();
  }

  refresh() {
    this.service.postData({
      cancel: true,
      report_type: this.report,
      day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
      month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
      year: this.year,
      status_pay: '1.1',
      date_filter: this.date_filter
    }, "reports-new/get_reports_all_bill").then((result: any) => {
      this.reports = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))

      var formatter = new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      });


      switch (this.report) {
        case '1':
        case '6':
        case '7':

          for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
            this.reports[tmb].number_row = (tmb + 1).toString();

            var xy = 0;
            xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

            if (xy < 2500) {
              xy = xy + 543;
            }

            this.reports[tmb].pay_datetime = moment(this.reports[tmb].pay_datetime).add(543, 'y').format("DD/MM/YYYY");

            this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
            this.total_price += parseFloat(this.reports[tmb].total_price);
            this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);
            this.reports[tmb].discount = formatter.format(this.reports[tmb].discount);
            this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);
          }

          this.total_price_value = formatter.format(this.total_price);
          this.isLoading = false;

          setTimeout(() => {
            window.print();
          }, 1000);
          break;


        }    // case '6':
        //   for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
        //     this.reports[tmb].number_row = (tmb + 1).toString();
        //     this.total_price += parseFloat(this.reports[tmb].total_price);
        //     this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);

        //     let x = this.service.postData({
        //       report_type: '41',
        //       day: (this.reports[tmb].days.toString().length == 1) ? '0' + this.reports[tmb].days.toString() : this.reports[tmb].days.toString(),
        //       month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
        //       year: this.year,
        //       cancel: true
        //     }, "reports-new/get_reports_all_bill").then((result2: any) => {
        //       //debugger;
        //       var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
        //       //debugger;

        //       if (res2.length > 0) {
        //         this.reports[tmb].ty01 = res2[0].ty01;
        //         this.reports[tmb].ty02 = res2[0].ty02;
        //       }

        //     })
        //   }

        //   this.total_price_value = formatter.format(this.total_price);
        //   this.isLoading = false;

        //   setTimeout(() => {
        //     window.print();
        //   }, 1000);
        //   break;

        // case '7':
        //   for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
        //     this.reports[tmb].number_row = (tmb + 1).toString();
        //     this.total_price += parseFloat(this.reports[tmb].total_price);

        //     let x = this.service.postData({
        //       report_type: '51', day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
        //       month: (this.reports[tmb].month.toString().length == 1) ? '0' + this.reports[tmb].month.toString() : this.reports[tmb].month.toString(),
        //       year: this.year,
        //       cancel: true
        //     }, "reports-new/get_reports_all_bill").then((result2: any) => {
        //       //debugger;
        //       var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
        //       //debugger;
        //       if (result2.data.length > 0) {
        //         this.reports[tmb].ty01 = res2[0].ty01;
        //         this.reports[tmb].ty02 = res2[0].ty02;
        //       }

        //     })


        //     switch (this.reports[tmb].month) {
        //       case '01':
        //         this.reports[tmb].month = 'มกราคม';
        //         break
        //       case '02':
        //         this.reports[tmb].month = 'กุมภาพันธ์';
        //         break
        //       case '03':
        //         this.reports[tmb].month = 'มีนาคม';
        //         break
        //       case '04':
        //         this.reports[tmb].month = 'เมษายน';
        //         break
        //       case '05':
        //         this.reports[tmb].month = 'พฤษภาคม';
        //         break
        //       case '06':
        //         this.reports[tmb].month = 'มิถุนายน';
        //         break
        //       case '07':
        //         this.reports[tmb].month = 'กรกฏาคม';
        //         break
        //       case '08':
        //         this.reports[tmb].month = 'สิงหาคม';
        //         break
        //       case '09':
        //         this.reports[tmb].month = 'กันยายน';
        //         break
        //       case '10':
        //         this.reports[tmb].month = 'ตุลาคม';
        //         break
        //       case '11':
        //         this.reports[tmb].month = 'พฤศจิกายน';
        //         break
        //       case '12':
        //         this.reports[tmb].month = 'ธันวาคม';
        //         break
        //     }

        //     this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);
        //   }

        //   this.total_price_value = formatter.format(this.total_price);
        //   this.isLoading = false;

        //   setTimeout(() => {
        //     window.print();
        //   }, 1000);
        //   break;



    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    });
  }

}
